


























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardDiagnosa from "@/components/pemeriksaan/resumeSuketV2/CardDiagnosa.vue";
import CardResumeRalan from "@/components/pemeriksaan/resumeSuketV2/CardResumeRalan.vue";
import CardSKDP from "@/components/pemeriksaan/resumeSuketV2/CardSKDP.vue";
import CardSKIstirahat from "@/components/pemeriksaan/resumeSuketV2/CardSKIstirahat.vue";
import CardSKJiwa from "@/components/pemeriksaan/resumeSuketV2/CardSKJiwa.vue";
import CardSKMata from "@/components/pemeriksaan/resumeSuketV2/CardSKMata.vue";
import CardSKNapza from "@/components/pemeriksaan/resumeSuketV2/CardSKNapza.vue";
import CardSKSehatJasmani from "@/components/pemeriksaan/resumeSuketV2/CardSKSehatJasmani.vue";
import CardSPRI from "@/components/pemeriksaan/resumeSuketV2/CardSPRI.vue";
import CardGeneralConsent from "@/components/pemeriksaan/tabs/persetujuan/CardGeneralConsent.vue";
import CardPernyataanKronologi from "@/components/pemeriksaan/tabs/persetujuan/CardPernyataanKronologi.vue";
import CardInformedConsentTindakan from "@/components/pemeriksaan/tabs/persetujuan/CardInformedConsentTindakan.vue";
import CardPersetujuanKb from "@/components/pemeriksaan/tabs/persetujuan/CardPersetujuanKb.vue";
import CardPermintaanKerohanian from "@/components/pemeriksaan/tabs/persetujuan/CardPermintaanKerohanian.vue";
import CardResumeHemodialisa from "@/components/pemeriksaan/tabs/surat-keterangan/CardResumeHemodialisa.vue";
import CardSuratCutiBersalin from "@/components/pemeriksaan/tabs/surat-keterangan/CardSuratCutiBersalin.vue";
import SuketMcuGigiMulutTabPage from "@/components/pemeriksaan/tabs/surat-keterangan/gigi/SuketMcuGigiMulutTabPage.vue";
import SuketPemeriksaanGigiMulutTabPage from "@/components/pemeriksaan/tabs/surat-keterangan/gigi/SuketPemeriksaanGigiMulutTabPage.vue";
import SkdAdopsiTabPage from "@/components/pemeriksaan/tabs/surat-keterangan/SkdAdopsiTabPage.vue";
import SuketDisabilitasTabPage from "@/components/pemeriksaan/tabs/surat-keterangan/SuketDisabilitasTabPage.vue";
import SuketForm77TabPage from "@/components/pemeriksaan/tabs/surat-keterangan/SuketForm77TabPage.vue";
import SuketSkbpmTabPage from "@/components/pemeriksaan/tabs/surat-keterangan/SuketSkbpmTabPage.vue";
import PersetujuanLayananDarahTabPage from "@/components/pemeriksaan/tabs/surat-keterangan/transfusi-darah/PersetujuanLayananDarahTabPage.vue";
import { SUKET_KEYS_LAYANAN_DARAH } from "@/components/pemeriksaan/tabs/surat-keterangan/transfusi-darah/persetujuanLayananDarah";
import CardVisumEtRepertum from "@/components/pemeriksaan/tabs/surat-keterangan/visum/CardVisumEtRepertum.vue";
import FormulirKlaimRehabMedikTabPage from "@/FormulirKlaimRehabMedikTabPage.vue";
import FormulirUjiFungsiKfrTabPage from "@/FormulirUjiFungsiKfrTabPage.vue";
import SuketFitToWorkTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketFitToWorkTabPage.vue";
import SuketGawatDaruratTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketGawatDaruratTabPage.vue";
import SuketKematianTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketKematianTabPage.vue";
import SuketKesanggupanDirujukTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketKesanggupanDirujukTabPage.vue";
import SuketKlaimProtesaGigiTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketKlaimProtesaGigiTabPage.vue";
import SuketKulitKelaminTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketKulitKelaminTabPage.vue";
import SuketPengawetanJenazahTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketPengawetanJenazahTabPage.vue";
import SuketLayakTerbangTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketLayakTerbangTabPage.vue";
import SuketLayakVaksinTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketLayakVaksinTabPage.vue";
import SuketMcuCpnsGol3TabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketMcuCpnsGol3TabPage.vue";
import SuketMcuGol2TabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketMcuGol2TabPage.vue";
import SuketMcuUmumTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketMcuUmumTabPage.vue";
import SuketSehatDalamTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketSehatDalamTabPage.vue";
import SuketSehatGigiTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketSehatGigiTabPage.vue";
import SuketSehatJiwaMmpiTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketSehatJiwaMmpiTabPage.vue";
import SuketSehatParuTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketSehatParuTabPage.vue";
import SuketSehatTHTTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketSehatTHTTabPage.vue";
import SuketTatoTindikTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketTatoTindikTabPage.vue";
import SuketTidakCacatTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketTidakCacatTabPage.vue";
import SuketTindakanHdTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketTindakanHdTabPage.vue";
import SuketTindakanUmumTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketTindakanUmumTabPage.vue";
import SuketVaksinasiTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketVaksinasiTabPage.vue";
import FormulirKlaimRehabMedik from "@/store/modules/FormulirKlaimRehabMedik";
import FormulirUjiFungsiKfr from "@/store/modules/FormulirUjiFungsiKfr";
import { storeGeneralConsent } from "@/store/modules/GeneralConsentStore";
import { storePernyataanKronologi } from "@/store/modules/PernyataanKronologiStore";
import storeICT from "@/store/modules/InformedConsentTindakanStore";
import { storePersetujuanKb } from "@/store/modules/PersetujuanKbStore";
import { storePermintaanKerohanian } from "@/store/modules/PermintaanKerohanianStore";
import PersetujuanTransfusiDarahStore from "@/store/modules/PersetujuanTransfusiDarah";
import PersetujuanTransfusiInkompatibelStore from "@/store/modules/PersetujuanTransfusiInkompatibel";
import PersetujuanPlebotomiStore from "@/store/modules/PersetujuanPlebotomi";
import { storeResumeHemodialisa } from "@/store/modules/ResumeHemodialisaStore";
import { storeResume } from "@/store/modules/resume";
import SuketBebasNapza from "@/store/modules/SuketBebasNapza";
import SuketDisabilitas from "@/store/modules/SuketDisabilitas";
import SuketFitToWork from "@/store/modules/SuketFitToWork";
import SuketForm77 from "@/store/modules/SuketForm77";
import SuketGawatDarurat from "@/store/modules/SuketGawatDarurat";
import SuketIstirahat from "@/store/modules/SuketIstirahat";
import SuketKematian from "@/store/modules/SuketKematian";
import SuketKesanggupanDirujuk from "@/store/modules/SuketKesanggupanDirujuk";
import SuketKlaimProtesaGigi from "@/store/modules/SuketKlaimProtesaGigi";
import SuketKulitKelamin from "@/store/modules/SuketKulitKelamin";
import SuketLayakTerbang from "@/store/modules/SuketLayakTerbang";
import SuketLayakVaksin from "@/store/modules/SuketLayakVaksin";
import SuketMata from "@/store/modules/SuketMata";
import SuketMcuCpnsGol3 from "@/store/modules/SuketMcuCpnsGol3";
import SuketMcuGigiMulut from "@/store/modules/SuketMcuGigiMulut";
import SuketMcuGol2 from "@/store/modules/SuketMcuGol2";
import SuketMcuUmum from "@/store/modules/SuketMcuUmum";
import SuketPemeriksaanGigiMulut from "@/store/modules/SuketPemeriksaanGigiMulut";
import SuketPengawetanJenazah from "@/store/modules/SuketPengawetanJenazah";
import SuketPulang from "@/store/modules/SuketPulang";
import SuketSehatDalam from "@/store/modules/SuketSehatDalam";
import SuketSehatJasmani from "@/store/modules/SuketSehatJasmani";
import SuketSehatJiwa from "@/store/modules/SuketSehatJiwa";
import SuketSehatParu from "@/store/modules/SuketSehatParu";
import SuketSehatTHT from "@/store/modules/SuketSehatTHT";
import SuketSkbpm from "@/store/modules/SuketSkbpm";
import SuketSkdAdopsi from "@/store/modules/SuketSkdAdopsi";
import SuketTatoTindik from "@/store/modules/SuketTatoTindik";
import SuketTidakCacat from "@/store/modules/SuketTidakCacat";
import SuketTindakanHd from "@/store/modules/SuketTindakanHd";
import SuketTindakanUmum from "@/store/modules/SuketTindakanUmum";
import SuketVaksinasi from "@/store/modules/SuketVaksinasi";
import storeCutiBersalin from "@/store/modules/SuratCutiBersalinStore";
import SuratKonsulRujukInternalStore from "@/store/modules/SuratKonsulRujukInternalStore";
import { storeSkDiagnosa } from "@/store/modules/skdiagnosa";
import { storeSKDP } from "@/store/modules/skdp";
import { storeSoap } from "@/store/modules/soap";
import { storeSpri } from "@/store/modules/spri";
import { userModule } from "@/store/modules/user";
import { storeVisumEtRepertum } from "@/store/modules/VisumEtRepertumStore";
import { scrollTabIntoView } from "@/utils/scrollTabIntoView";
import { isUnitPengawetanJenazah } from "@/utils/unit";
import SuketIndex, {
	SuketTabSource,
	bySuket,
	byRegister,
	byKeys,
	childFetches
} from "@/services/SuketIndex";
import SuketPulangCard from "./SuketPulangCard.vue";

const SUKET_CATEGORY_ORDER: string[] = [
	"Resume & Rawat",
	"Surat Sehat",
	"Gigi & Mulut",
	"Surat Khusus",
	"Persetujuan",
	"Rehab Medik",
	"Lainnya",
];

const SUKET_TAB_CATEGORY: Record<string, string> = {
	// Resume & Rawat
	"tab-resume": "Resume & Rawat",
	"tab-resume-hemodialisa": "Resume & Rawat",
	"tab-spri": "Resume & Rawat",
	"tab-skdp": "Resume & Rawat",
	// Surat Sehat
	"tab-sehat": "Surat Sehat",
	"tab-jiwa": "Surat Sehat",
	"tab-jiwa-mmpi": "Surat Sehat",
	"tab-napza": "Surat Sehat",
	"tab-sk-mata": "Surat Sehat",
	"tab-sk-sehat-paru": "Surat Sehat",
	"tab-sk-sehat-tht": "Surat Sehat",
	"tab-sk-dalam": "Surat Sehat",
	"tab-sk-layak-terbang": "Surat Sehat",
	"tab-sk-fit-to-work": "Surat Sehat",
	"tab-sk-layak-vaksin": "Surat Sehat",
	"tab-sk-vaksin": "Surat Sehat",
	"tab-sk-tidak-cacat": "Surat Sehat",
	"tab-skd-adopsi": "Surat Sehat",
	"tab-skbpm": "Surat Sehat",
	"tab-sk-disabilitas": "Surat Sehat",
	"tab-sk-tato-tindik": "Surat Sehat",
	// Gigi & Mulut
	"tab-sk-gigi": "Gigi & Mulut",
	"tab-sk-pemeriksaan-gigi-mulut": "Gigi & Mulut",
	"tab-sk-mcu-gigi-mulut": "Gigi & Mulut",
	"tab-sk-klaim-protesa-gigi": "Gigi & Mulut",
	// Surat Khusus
	"tab-diagnosa": "Surat Khusus",
	"tab-istirahat": "Surat Khusus",
	"tab-sk-pulang": "Surat Khusus",
	"tab-sk-gawat-darurat": "Surat Khusus",
	"tab-kesanggupan-dirujuk": "Surat Khusus",
	"tab-sk-kematian": "Surat Khusus",
	"tab-sk-pengawetan-jenazah": "Surat Khusus",
	"tab-cuti-bersalin": "Surat Khusus",
	"tab-visum": "Surat Khusus",
	// Persetujuan
	"tab-general-consent": "Persetujuan",
	"tab-kronologi": "Persetujuan",
	"tab-persetujuan-transfusi-darah": "Persetujuan",
	"tab-informed-consent-tindakan": "Persetujuan",
	"tab-persetujuan-kb": "Persetujuan",
	"tab-permintaan-kerohanian": "Persetujuan",
	// Rehab Medik
	"tab-form-klaim-rehab-medik": "Rehab Medik",
	"tab-form-uji-fungsi-kfr": "Rehab Medik",
	// Lainnya — MCU & pemeriksaan kesehatan pegawai
	"tab-form-77": "Lainnya",
	"tab-sk-mcu-cpns-gol3": "Lainnya",
	"tab-sk-mcu-umum": "Lainnya",
	"tab-sk-mcu-gol-2": "Lainnya",
};

const SUKET_TAB_SOURCE: Record<string, SuketTabSource> = {
	"tab-resume": {
		key: "resume-ralan",
		fetch: (r, uid) => storeResume.act_resume_on_reg({ reg: r, idUser: uid })
	},
	"tab-resume-hemodialisa": {
		key: "resume-hemodialisa",
		fetch: r => storeResumeHemodialisa.fetchByRegister(r)
	},
	"tab-spri": { key: "spri", fetch: r => storeSpri.act_spri_on_reg(r) },
	"tab-skdp": childFetches("skdp"),
	"tab-diagnosa": childFetches("suket-diagnosa"),
	"tab-sehat": bySuket("suket-sehat-jasmani", SuketSehatJasmani),
	"tab-jiwa": bySuket("suket-sehat-jiwa", SuketSehatJiwa),
	"tab-napza": bySuket("suket-bebas-napza", SuketBebasNapza),
	"tab-istirahat": bySuket("suket-istirahat", SuketIstirahat),
	"tab-sk-mata": bySuket("suket-mata", SuketMata),
	"tab-sk-sehat-paru": bySuket("sehat-paru", SuketSehatParu),
	"tab-sk-sehat-tht": bySuket("sehat-tht", SuketSehatTHT),
	"tab-sk-pulang": bySuket("pulang", SuketPulang),
	"tab-sk-gawat-darurat": bySuket("gawat-darurat", SuketGawatDarurat),
	"tab-kesanggupan-dirujuk": bySuket(
		"kesanggupan-dirujuk",
		SuketKesanggupanDirujuk
	),
	"tab-sk-kematian": bySuket("kematian", SuketKematian),
	"tab-sk-pengawetan-jenazah": bySuket(
		"pengawetan-jenazah",
		SuketPengawetanJenazah
	),
	"tab-sk-layak-terbang": bySuket("layak-terbang", SuketLayakTerbang),
	"tab-sk-fit-to-work": bySuket("fit-to-work", SuketFitToWork),
	"tab-sk-dalam": bySuket("sehat-dalam", SuketSehatDalam),
	"tab-skd-adopsi": bySuket("skd-adopsi", SuketSkdAdopsi),
	"tab-skbpm": bySuket("skbpm", SuketSkbpm),
	"tab-form-77": bySuket("form-77", SuketForm77),
	"tab-sk-mcu-cpns-gol3": bySuket("mcu-cpns-gol3", SuketMcuCpnsGol3),
	"tab-sk-layak-vaksin": bySuket("layak-vaksin", SuketLayakVaksin),
	"tab-sk-vaksin": bySuket("vaksin", SuketVaksinasi),
	"tab-sk-pemeriksaan-gigi-mulut": bySuket(
		"pemeriksaan-gigi-mulut",
		SuketPemeriksaanGigiMulut
	),
	"tab-sk-mcu-gigi-mulut": bySuket("mcu-gigi-mulut", SuketMcuGigiMulut),
	"tab-sk-klaim-protesa-gigi": bySuket(
		"klaim-protesa-gigi",
		SuketKlaimProtesaGigi
	),
	"tab-sk-mcu-umum": bySuket("mcu-umum", SuketMcuUmum),
	"tab-sk-mcu-gol-2": bySuket("mcu-gol-2", SuketMcuGol2),
	"tab-sk-tindakan-umum": bySuket("tindakan-umum", SuketTindakanUmum),
	"tab-sk-tindakan-hd": bySuket("tindakan-hd", SuketTindakanHd),
	"tab-sk-disabilitas": bySuket("disabilitas", SuketDisabilitas),
	"tab-sk-tidak-cacat": bySuket("tidak-cacat", SuketTidakCacat),
	"tab-sk-tato-tindik": bySuket("tato-tindik", SuketTatoTindik),
	"tab-sk-kulit-kelamin": bySuket("kulit-kelamin", SuketKulitKelamin),
	"tab-general-consent": byRegister("general-consent", storeGeneralConsent),
	"tab-kronologi": byRegister(
		"pernyataan-kronologi",
		storePernyataanKronologi
	),
	"tab-persetujuan-transfusi-darah": byKeys(SUKET_KEYS_LAYANAN_DARAH),
	"tab-visum": byRegister("visum-et-repertum", storeVisumEtRepertum),
	"tab-informed-consent-tindakan": byRegister(
		"informed-consent-tindakan",
		storeICT
	),
	"tab-cuti-bersalin": childFetches("surat-cuti-bersalin"),
	"tab-persetujuan-kb": childFetches("persetujuan-kb"),
	"tab-permintaan-kerohanian": childFetches("permintaan-kerohanian"),
	"tab-form-klaim-rehab-medik": byRegister(
		"klaim-ralan-rehab-medik",
		FormulirKlaimRehabMedik
	),
	"tab-form-uji-fungsi-kfr": byRegister("uji-fungsi-kfr", FormulirUjiFungsiKfr)
};

@Component({
	components: {
		CardResumeRalan,
		CardResumeHemodialisa,
		CardSPRI,
		CardSKDP,
		CardDiagnosa,
		CardSKSehatJasmani,
		CardSKJiwa,
		CardSKNapza,
		CardSKIstirahat,
		CardSKMata,
		SuketSehatJiwaMmpiTabPage,
		SuketSehatParuTabPage,
		SuketPulangCard,
		SuketSehatTHTTabPage,
		SuketGawatDaruratTabPage,
		SuketKesanggupanDirujukTabPage,
		SuketKematianTabPage,
		SuketPengawetanJenazahTabPage,
		SuketLayakTerbangTabPage,
		SuketFitToWorkTabPage,
		SuketLayakVaksinTabPage,
		SuketVaksinasiTabPage,
		SuketSehatDalamTabPage,
		SkdAdopsiTabPage,
		SuketSkbpmTabPage,
		SuketForm77TabPage,
		SuketMcuCpnsGol3TabPage,
		SuketSehatGigiTabPage,
		SuketPemeriksaanGigiMulutTabPage,
		SuketMcuGigiMulutTabPage,
		SuketKlaimProtesaGigiTabPage,
		SuketMcuUmumTabPage,
		SuketMcuGol2TabPage,
		SuketTindakanUmumTabPage,
		SuketTindakanHdTabPage,
		SuketDisabilitasTabPage,
		SuketTidakCacatTabPage,
		SuketTatoTindikTabPage,
		SuketKulitKelaminTabPage,
		FormulirKlaimRehabMedikTabPage,
		FormulirUjiFungsiKfrTabPage,
		PersetujuanLayananDarahTabPage,
		CardVisumEtRepertum,
		CardInformedConsentTindakan,
		CardSuratCutiBersalin,
		CardPersetujuanKb,
		CardPermintaanKerohanian,
		CardGeneralConsent,
		CardPernyataanKronologi,
	},
})
export default class CardSuket extends Vue {
	@Prop() register!: string;
	@Prop() rm!: string;
	@Prop() dtResume!: object;
	@Prop({ default: null }) deepLink!: any;
	@Prop({ default: () => [] }) categories!: string[];
	@Prop({ default: () => [] }) excludeCategories!: string[];
	@Prop({ default: "tab-suket" }) hostTab!: string;

	modalSpri: boolean;
	sess_login = this.stateuser;
	tab = "";
	modalTambahSpri = false;
	pageTab = "tab-soap";
	expandInput = false;
	activeCategory = "Resume & Rawat";
	tabSearch = "";

	suketIndex: Record<string, number> = {};
	loadedTabs: Record<string, boolean> = {};

	// Certificate tabs that pass their visibility gate, annotated with their category.
	get gatedTabs() {
		return this.tabTitle
			.filter((t) => t.visible)
			.map((t) => ({
				...t,
				category: SUKET_TAB_CATEGORY[t.val] || "Lainnya",
			}))
			.filter(
				(t) =>
					(!this.categories.length || this.categories.includes(t.category)) &&
					!this.excludeCategories.includes(t.category),
			);
	}

	get defaultTab(): string {
		const first = this.filteredTabs[0];
		return this.filteredTabs.some((t) => t.val === "tab-resume") || !first
			? "tab-resume"
			: first.val;
	}

	// Categories that currently have at least one visible tab, in display order.
	get visibleCategories(): string[] {
		const present = new Set(this.gatedTabs.map((t) => t.category));
		const ordered = SUKET_CATEGORY_ORDER.filter((c) => present.has(c));
		present.forEach((c) => {
			if (!ordered.includes(c)) {
				ordered.push(c);
			}
		});
		return ordered;
	}

	// Tabs shown in the sidebar: a search query (matched on the title) overrides
	// the category filter; otherwise show only the active category.
	get filteredTabs() {
		const q = (this.tabSearch || "").toLowerCase().trim();
		if (q) {
			return this.gatedTabs.filter((t) =>
				(t.title || "").toLowerCase().includes(q),
			);
		}
		return this.gatedTabs.filter((t) => t.category === this.activeCategory);
	}

	// When the category changes, keep the active tab if still listed, otherwise
	// jump to the first tab of the newly selected category.
	@Watch("activeCategory")
	onActiveCategoryChange() {
		const stillVisible = this.filteredTabs.some((t) => t.val === this.tab);
		if (!stillVisible && this.filteredTabs.length) {
			this.tab = this.filteredTabs[0].val;
		}
	}

	// Universal-search deep link (PasienFlyingBar -> Pemeriksaan -> here): activate
	// the target category then select the form. Guarded by topTab so the shared
	// prop is ignored unless the search targets the Surat Keterangan host.
	@Watch("deepLink", { immediate: true })
	onDeepLink(payload: any) {
		if (!payload || payload.topTab !== this.hostTab || !payload.elemId) {
			return;
		}
		this.tabSearch = "";
		if (payload.category) {
			this.activeCategory = payload.category;
		}
		this.tab = payload.elemId;
	}

	created() {
		if (
			!this.visibleCategories.includes(this.activeCategory) &&
			this.visibleCategories.length
		) {
			this.activeCategory = this.visibleCategories[0];
		}
	}

	mounted() {
		// Skip the default tab when a universal-search deep link already picked one.
		const dl = this.deepLink;
		if (!dl || dl.topTab !== this.hostTab || !dl.elemId) {
			this.tab = this.defaultTab;
		}

		if (!SuratKonsulRujukInternalStore.updated) {
			SuratKonsulRujukInternalStore.getListByRegister(parseInt(this.register));
		}

		SuketIndex.getByRegister(this.register).then((map) => {
			this.suketIndex = map;
		});

		this.loadTab(this.tab);
	}

	@Watch("tab")
	onTabChange(val: string) {
		this.loadTab(val);
		this.$nextTick(() => scrollTabIntoView(this.$el));
	}

	loadTab(val: string) {
		const src = val && !this.loadedTabs[val] && SUKET_TAB_SOURCE[val];
		if (!src) {
			return;
		}

		this.$set(this.loadedTabs, val, true);

		if (src.fetch) {
			src.fetch(this.register, this.sess_login.id);
		}
	}

	hasSurat(tab: any): boolean {
		const src = SUKET_TAB_SOURCE[tab.val];
		if (!src) {
			return !!tab.data;
		}
		return this.loadedTabs[tab.val]
			? !!tab.data
			: (src.keys || [src.key]).some((key) => !!this.suketIndex[key]);
	}

	get tabTitle() {
		const items = [
			{
				val: "tab-resume",
				loading: storeResume.loading,
				iconText: "mdi-clipboard-list-outline",
				title: "Resume Rawat Jalan",
				data: storeResume.resume.length,
				component: "CardResumeRalan",
				visible: true,
			},
			{
				val: "tab-resume-hemodialisa",
				loading: storeResumeHemodialisa.loading,
				iconText: "mdi-water-outline",
				title: "Resume Hemodialisa JKN",
				data: storeResumeHemodialisa.item ? 1 : 0,
				component: "CardResumeHemodialisa",
				visible: this.stateuser.unit_group_id == "37",
			},
			{
				val: "tab-spri",
				loading: storeSpri.loading,
				iconText: "mdi-bed-outline",
				title: "Surat Perintah Rawat Inap",
				data: storeSpri.spri.length,
				component: "CardSPRI",
				visible: true,
			},
			{
				val: "tab-skdp",
				loading: storeSKDP.loading,
				iconText: "mdi-note-text-outline",
				title: "Surat Keterangan DPJP (SKDP)",
				data: storeSKDP.skdp.length,
				component: "CardSKDP",
				visible: true,
			},
			{
				val: "tab-diagnosa",
				loading: storeSkDiagnosa.loading,
				iconText: "mdi-stethoscope",
				title: "Surat Keterangan Diagnosa",
				data: storeSkDiagnosa.skDiagnosa.length,
				component: "CardDiagnosa",
				visible: true,
			},
			{
				val: "tab-sehat",
				loading: SuketSehatJasmani.loading,
				iconText: "mdi-clipboard-pulse-outline",
				title: "Surat Keterangan Dokter",
				data: SuketSehatJasmani.suket.length,
				component: "CardSKSehatJasmani",
				visible: true,
			},
			{
				val: "tab-jiwa",
				loading: SuketSehatJiwa.loading,
				iconText: "mdi-head-cog-outline",
				title: "Surat Keterangan Sehat Jiwa",
				data: SuketSehatJiwa.suket,
				component: "CardSKJiwa",
				visible: true,
			},
			// {
			//   val: "tab-jiwa-mmpi",
			//   loading: SuketSehatJiwaMmpi.loading,
			//   iconText: "mdi-head-cog-outline",
			//   title: "Surat Keterangan Sehat Jiwa MMPI",
			//   data: SuketSehatJiwaMmpi.suket,
			//   component: "SuketSehatJiwaMmpiTabPage"
			// },
			{
				val: "tab-napza",
				loading: SuketBebasNapza.loading,
				iconText: "mdi-pill",
				title: "Surat Keterangan Bebas Napza",
				data: SuketBebasNapza.suket,
				component: "CardSKNapza",
				visible: true,
			},
			{
				val: "tab-istirahat",
				loading: SuketIstirahat.loading,
				iconText: "mdi-sleep",
				title: "Surat Keterangan Istirahat",
				data: SuketIstirahat.suket.length,
				component: "CardSKIstirahat",
				visible: true,
			},
			{
				val: "tab-sk-mata",
				loading: SuketMata.loading,
				iconText: "mdi-eye",
				title: "Surat Keterangan Mata",
				data: SuketMata.suket,
				component: "CardSKMata",
				visible: true,
			},
			{
				val: "tab-sk-sehat-paru",
				loading: SuketSehatParu.loading,
				iconText: "mdi-lungs",
				title: "Surat Keterangan Sehat Paru",
				data: SuketSehatParu.suket,
				component: "SuketSehatParuTabPage",
				visible: true,
			},
			{
				val: "tab-sk-sehat-tht",
				loading: SuketSehatTHT.loading,
				iconText: "mdi-ear-hearing",
				title: "Surat Keterangan Sehat THT",
				data: SuketSehatTHT.suket,
				component: "SuketSehatTHTTabPage",
				visible: true,
			},
			{
				val: "tab-sk-pulang",
				loading: SuketPulang.loading,
				iconText: "mdi-home",
				title: "Surat Pemulangan Pasien IGD",
				data: SuketPulang.suket,
				component: "SuketPulangCard",
				visible: true,
			},
			{
				val: "tab-sk-gawat-darurat",
				loading: SuketGawatDarurat.loading,
				iconText: "mdi-car-brake-alert",
				title: "Surat Keterangan Gawat Darurat",
				data: SuketGawatDarurat.suket,
				component: "SuketGawatDaruratTabPage",
				visible: true,
			},
			{
				// Blanko menyebut "dokter jaga IGD" → hanya relevan di IGD.
				val: "tab-kesanggupan-dirujuk",
				loading: SuketKesanggupanDirujuk.loading,
				iconText: "mdi-ambulance",
				title: "Surat Pernyataan Kesanggupan Dirujuk",
				data: SuketKesanggupanDirujuk.suket ? 1 : 0,
				component: "SuketKesanggupanDirujukTabPage",
				visible: this.stateuser.unit_id === "01",
			},
			{
				val: "tab-sk-kematian",
				loading: SuketKematian.loading,
				iconText: "mdi-skull",
				title: "Surat Keterangan Kematian",
				data: SuketKematian.suket,
				component: "SuketKematianTabPage",
				visible: true,
			},
			{
				val: "tab-sk-pengawetan-jenazah",
				loading: SuketPengawetanJenazah.loading,
				iconText: "mdi-flask-outline",
				title: "Surat Keterangan Pengawetan Jenazah",
				data: SuketPengawetanJenazah.suket ? 1 : 0,
				component: "SuketPengawetanJenazahTabPage",
				visible: isUnitPengawetanJenazah(this.stateuser.unit_id),
			},
			{
				val: "tab-sk-layak-terbang",
				loading: SuketLayakTerbang.loading,
				iconText: "mdi-airplane",
				title: "Surat Layak Terbang",
				data: SuketLayakTerbang.suket,
				component: "SuketLayakTerbangTabPage",
				visible: true,
			},
			{
				val: "tab-sk-fit-to-work",
				loading: SuketFitToWork.loading,
				iconText: "mdi-run",
				title: "Surat Keterangan Fit To Work",
				data: SuketFitToWork.suket,
				component: "SuketFitToWorkTabPage",
				visible: true,
			},
			{
				val: "tab-sk-dalam",
				loading: SuketSehatDalam.loading,
				iconText: "mdi-stomach",
				title: "Surat Keterangan Sehat Dalam",
				data: SuketSehatDalam.suket,
				component: "SuketSehatDalamTabPage",
				visible: true,
			},
			{
				val: "tab-skd-adopsi",
				loading: SuketSkdAdopsi.loading,
				iconText: "mdi-baby-face-outline",
				title: "SKD Adopsi",
				data: SuketSkdAdopsi.suket,
				component: "SkdAdopsiTabPage",
				visible: true,
			},
			{
				val: "tab-skbpm",
				loading: SuketSkbpm.loading,
				iconText: "mdi-shield-check-outline",
				title: "Surat Keterangan Bebas Penyakit Menular",
				data: SuketSkbpm.suket,
				component: "SuketSkbpmTabPage",
				visible: true,
			},
			{
				val: "tab-form-77",
				loading: SuketForm77.loading,
				iconText: "mdi-clipboard-account",
				title: "Form 77 (Pemeriksaan Kesehatan PNS)",
				data: SuketForm77.suket,
				component: "SuketForm77TabPage",
				visible: this.stateuser.unit_group_id != "01",
			},
			{
				val: "tab-sk-mcu-cpns-gol3",
				loading: SuketMcuCpnsGol3.loading,
				iconText: "mdi-account-tie",
				title: "MCU CPNS Golongan III (TPK)",
				data: SuketMcuCpnsGol3.suket ? 1 : 0,
				component: "SuketMcuCpnsGol3TabPage",
				visible: this.stateuser.unit_group_id == "2Q",
			},
			{
				val: "tab-sk-layak-vaksin",
				loading: SuketLayakVaksin.loading,
				iconText: "mdi-shield-check",
				title: "Surat Keterangan Layak Vaksin",
				data: SuketLayakVaksin.suket,
				component: "SuketLayakVaksinTabPage",
				visible: true,
			},
			{
				val: "tab-sk-vaksin",
				loading: SuketVaksinasi.loading,
				iconText: "mdi-needle",
				title: "Surat Keterangan Vaksinasi",
				data: SuketVaksinasi.suket,
				component: "SuketVaksinasiTabPage",
				visible: true,
			},
			// {
			//   val: "tab-sk-gigi",
			//   loading: SuketSehatGigi.loading,
			//   iconText: "mdi-tooth-outline",
			//   title: "Surat Keterangan Sehat Gigi",
			//   data: SuketSehatGigi.suket,
			//   component: "SuketSehatGigiTabPage",
			// },
			{
				val: "tab-sk-pemeriksaan-gigi-mulut",
				loading: SuketPemeriksaanGigiMulut.loading,
				iconText: "mdi-tooth-outline",
				title: "Surat Keterangan Pemeriksaan Gigi & Mulut",
				data: SuketPemeriksaanGigiMulut.suket ? 1 : 0,
				component: "SuketPemeriksaanGigiMulutTabPage",
				visible: this.stateuser.unit_group_id == "03",
			},
			{
				val: "tab-sk-mcu-gigi-mulut",
				loading: SuketMcuGigiMulut.loading,
				iconText: "mdi-tooth",
				title: "MCU Gigi & Mulut (Medical Check-Up)",
				data: SuketMcuGigiMulut.suket ? 1 : 0,
				component: "SuketMcuGigiMulutTabPage",
				visible: this.stateuser.unit_group_id == "03",
			},
			{
				val: "tab-sk-klaim-protesa-gigi",
				loading: SuketKlaimProtesaGigi.loading,
				iconText: "mdi-tooth-outline",
				title: "Surat Klaim Protesa Gigi",
				data: SuketKlaimProtesaGigi.suket ? 1 : 0,
				component: "SuketKlaimProtesaGigiTabPage",
				visible: this.stateuser.unit_group_id == "03",
			},
			{
				val: "tab-sk-mcu-umum",
				loading: SuketMcuUmum.loading,
				iconText: "mdi-clipboard-pulse",
				title: "Hasil Medical Check-Up (MCU Umum)",
				data: SuketMcuUmum.suket ? 1 : 0,
				component: "SuketMcuUmumTabPage",
				visible: this.stateuser.unit_group_id == "2Q",
			},
			{
				val: "tab-sk-mcu-gol-2",
				loading: SuketMcuGol2.loading,
				iconText: "mdi-clipboard-account-outline",
				title: "MCU Gol. II — Hasil Pengujian Kesehatan PNS (DPT)",
				data: SuketMcuGol2.suket ? 1 : 0,
				component: "SuketMcuGol2TabPage",
				visible: this.stateuser.unit_group_id == "2Q",
			},
			{
				val: "tab-sk-tindakan-umum",
				loading: SuketTindakanUmum.loading,
				iconText: "mdi-clipboard-pulse-outline",
				title: "Surat Keterangan Tindakan",
				data: SuketTindakanUmum.suket ? 1 : 0,
				component: "SuketTindakanUmumTabPage",
				visible: true,
			},
			{
				val: "tab-sk-tindakan-hd",
				loading: SuketTindakanHd.loading,
				iconText: "mdi-water-pump",
				title: "Surat Keterangan Tindakan HD",
				data: SuketTindakanHd.suket ? 1 : 0,
				component: "SuketTindakanHdTabPage",
				visible: this.stateuser.unit_group_id == "37",
			},
			{
				val: "tab-sk-disabilitas",
				loading: SuketDisabilitas.loading,
				iconText: "mdi-wheelchair-accessibility",
				title: "Surat Keterangan Disabilitas",
				data: 0,
				component: "SuketDisabilitasTabPage",
				visible: true,
			},
			{
				val: "tab-sk-tidak-cacat",
				loading: SuketTidakCacat.loading,
				iconText: "mdi-human",
				title: "Surat Keterangan Tidak Cacat Fisik",
				data: SuketTidakCacat.suket,
				component: "SuketTidakCacatTabPage",
				visible: true,
			},
			{
				val: "tab-sk-tato-tindik",
				loading: SuketTatoTindik.loading,
				iconText: "mdi-palette",
				title: "Surat Keterangan Tato Tindik",
				data: SuketTatoTindik.suket,
				component: "SuketTatoTindikTabPage",
				visible: true,
			},
			{
				val: "tab-general-consent",
				loading: storeGeneralConsent.loading,
				iconText: "mdi-file-document-check-outline",
				title: "Persetujuan Umum / General Consent",
				data: storeGeneralConsent.consent ? 1 : 0,
				component: "CardGeneralConsent",
				visible: true,
			},
			{
				val: "tab-kronologi",
				loading: storePernyataanKronologi.loading,
				iconText: "mdi-file-document-alert-outline",
				title: "Surat Pernyataan Kronologi",
				data: storePernyataanKronologi.items.length,
				component: "CardPernyataanKronologi",
				visible: true,
			},
			{
				val: "tab-persetujuan-transfusi-darah",
				loading:
					PersetujuanTransfusiDarahStore.loading ||
					PersetujuanTransfusiInkompatibelStore.loading ||
					PersetujuanPlebotomiStore.loading,
				iconText: "mdi-blood-bag",
				title: "Persetujuan Layanan Darah",
				data:
					PersetujuanTransfusiDarahStore.suket.length +
					PersetujuanTransfusiInkompatibelStore.suket.length +
					PersetujuanPlebotomiStore.suket.length,
				component: "PersetujuanLayananDarahTabPage",
				visible: true,
			},
			{
				val: "tab-visum",
				loading: storeVisumEtRepertum.loading,
				iconText: "mdi-scale-balance",
				title: "Visum et Repertum",
				data: storeVisumEtRepertum.listVisum.length,
				component: "CardVisumEtRepertum",
				visible: true,
			},
			{
				val: "tab-informed-consent-tindakan",
				loading: storeICT.loading,
				iconText: "mdi-file-document-edit",
				title: "Informed Consent Tindakan",
				data: storeICT.items.length,
				component: "CardInformedConsentTindakan",
				visible: true,
			},
			{
				val: "tab-cuti-bersalin",
				loading: storeCutiBersalin.loading,
				iconText: "mdi-baby-face-outline",
				title: "Surat Keterangan Cuti Bersalin",
				data: storeCutiBersalin.items.length,
				component: "CardSuratCutiBersalin",
				visible: true,
			},
			{
				val: "tab-persetujuan-kb",
				loading: storePersetujuanKb.loading,
				iconText: "mdi-baby-carriage-off",
				title: "Persetujuan Pelayanan KB",
				data: storePersetujuanKb.items.length,
				component: "CardPersetujuanKb",
				visible: true,
			},
			{
				val: "tab-permintaan-kerohanian",
				loading: storePermintaanKerohanian.loading,
				iconText: "mdi-hand-heart",
				title: "Permintaan Pelayanan Kerohanian",
				data: storePermintaanKerohanian.items.length,
				component: "CardPermintaanKerohanian",
				visible: this.stateuser.unit_id === "01",
			},
			{
				val: "tab-sk-kulit-kelamin",
				loading: SuketKulitKelamin.loading,
				iconText: "mdi-spa",
				title: "Surat Keterangan Kulit & Kelamin",
				data: SuketKulitKelamin.suket,
				component: "SuketKulitKelaminTabPage",
				visible: true,
			},
			{
				val: "tab-form-klaim-rehab-medik",
				loading: FormulirKlaimRehabMedik.loading,
				iconText: "mdi-walk",
				title: "Formulir Klaim Rehab Medik",
				data: FormulirKlaimRehabMedik.formulir,
				component: "FormulirKlaimRehabMedikTabPage",
				visible: this.stateuser.unit_group_id == "11",
			},
			{
				val: "tab-form-uji-fungsi-kfr",
				loading: FormulirUjiFungsiKfr.loading,
				iconText: "mdi-walk",
				title: "Formulir Uji Fungsi KFR",
				data: FormulirUjiFungsiKfr.formulir,
				component: "FormulirUjiFungsiKfrTabPage",
				visible: this.stateuser.unit_group_id == "11",
			},
		];

		return items;
	}

	get stateuser() {
		return userModule.user;
	}
	get statesoapdetail() {
		return storeSoap.detailSoap;
	}

	showTab(item) {
		// this.tabs=item
		this.tab = item;
		this.$emit("pageTab", item);
		// this.respResumes=item
		// console.log('1resr ',item)
	}
	backPageSoap() {
		this.$emit("pageTab", this.pageTab);
	}
}
